/**
 * SessionLoadingScreen — Full-screen branded loading state shown while
 * the user's session is being verified after sign-in.
 *
 * Displays the Metaphysical Labs icon with an animated progress bar.
 */
export function SessionLoadingScreen() {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#020617]">
      {/* Metaphysical Labs Icon */}
      <div className="mb-8 animate-pulse">
        <img
          src="/sidebar-logo.svg"
          alt="Metaphysical Labs"
          className="size-16"
        />
      </div>

      {/* Loading bar */}
      <div className="w-48 overflow-hidden rounded-full bg-white/10">
        <div className="loading-bar h-1 rounded-full bg-gradient-to-r from-[#8181FF] to-[#FD936E]" />
      </div>

      {/* Subtle text */}
      <p className="mt-4 text-xs text-slate-500">Loading your workspace...</p>
    </div>
  );
}
